<template>
  <div class="home">
    <h1>Home Run Derby {{ selectedYear }}</h1>
    <div class="row">
      <div class="cell">
        <LeaderBoard title="HRD Leaders" field="points"/>
      </div>    
      <div class="cell">
        <LeaderBoard title="Projected Points" field="projectedPoints"/>
      </div> 
      <div class="cell">
        <LeaderBoard title="% of Overall Target" field="percentOfTarget"/>
      </div>
         <div class="cell">
        <LeaderBoard title="Total Home Runs" field="hr"/>
      </div>  
      <div class="cell">
        <LeaderBoard title="Total Plate Appearences" field="plateAppearances"/>
      </div>  
      <div class="cell">
        <LeaderBoard title="Games Played" field="games"/>
      </div> 
    </div>
    </div>
</template>

<script>
// @ is an alias to /src
import LeaderBoard from '@/components/LeaderBoard.vue'
import getTeamsMixin from '@/data/get-teams-mixin.js'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'leaderboard',
  mixins: [getTeamsMixin],
  components: {
    LeaderBoard
  },
  computed: {
    ...mapState('teamData', ['selectedYear'])
  },
  created() {
    // Ensure data is loaded when this view is created
    this.ensureDataLoaded()
  },
  methods: {
    ...mapActions('teamData', ['initializeYearFromStorage']),
    async ensureDataLoaded() {
      // Check if we have data, if not, initialize it
      if (!this.teamData || Object.keys(this.teamData).length === 0) {
        await this.initializeYearFromStorage()
      }
    }
  }
}
</script>

<style>
div.cell {
  float: left;
  width: 280px;
  padding: 50, 50;
  border: 2px solid grey;
}

@media screen and (max-width: 600px) {
  div.cell {
    width: 100%;
  }
}

.row:after {
  content: "";
  display: table;
  clear: both;
}
</style>

